module.exports = __webpack_public_path__ + "img/ICONO2.1ab07899.png";